import styled from 'styled-components';

export const Split = styled.div`
  display: grid;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    row-gap: 3rem;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    gap: 8rem;
  }
`;

export const Title = styled.h4`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3.2rem;
  margin-bottom: 6rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 3.8rem;
    text-align: center;
    margin-bottom: 8rem;
  }
`;
